import React from 'react';
import NavButton from '../../homepage/header-banner/TopNavButton';
import TrafficFee from '../../homepage/header-banner/TrafficFee';
import MySql from '../../homepage/header-banner/MySql';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import CardBox from '../../container/Box/Components/CardBox'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Grid from '@mui/material/Grid';
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import ClickHouse from '../../homepage/header-banner/ClickHouse';
import FeeAndSupport from '../../container/Table/Components/FeeAndSupport';
import KubernetesTable from '../../container/Table/Components/KubernetesTable';
import { Box } from '@mui/material';
import '../../Style/typo.css'
import DividerComponent from '../../container/Divider/divider';

function ClusterClickHouseTest(){

    return (
        <div className='App'>
            <NavButton />
            {/* {Banner("HANBIRO CLOUD","Kubernetes ClickHouse")} */}
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        <Sidebar />
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for ClickHouse")}
                        {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>{CardBox(
                                "실시간 온라인분석처리(OLAP) 를 위한 오픈소스 컬럼 기반 DBMS", 
                                `<p>데이터는 사용 가능한 노드 에 기록 된후 모든 노드에 복재본이 배포됩니다.</p> <br>
                                <p>페타 바이트 규모의 데이터를 저장하고 처리 할 수 있습니다.</p> <br>
                                <p>전통적인 DBMS 보다 100배이상 빠르고, 실시간 온라인 데이터 분석에 사용됩니다.</p>`
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12}>{CardBox(
                                "데이터를 Shard에 분산저장하며, 비동기 멀티 마스터 지원",
                                `Multi-master 비동기 복제를 지원하며, 복제된 임의의 노드에서 데이터수집합니다. <br>
                                데이터를 Shard 에 분산저장하며, 연산결과를 병렬로 실행하며 병합합니다.`
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12}>{CardBox(
                                "고성능의 Persistant Volume 운영, I/O 최적의 성능구현",
                                `SSD 기반의 PV 볼륨으로 운영되고 있으며, 3개의 replica 컨테이너(POD)가 하나의 서비스단위입니다. <br>
                                쿠버네티스 워커노드의 하드웨어 장애시에도 타 워커노드의 replica 컨테이너(POD)에서 서비스가 진행됩니다.`
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12}>{CardBox(
                                "하드웨어장애시 타 워커노드에 컨테이너(POD) 자동으로 재배치 무정지시스템구현",
                                `Kubernetes ClickHouse 컨테이너(POD)는 단위서비스별 3개의 replica 노드로 구성되어 있습니다. <br> 
                                각각의 replica 컨테이너(POD)는 쿠버네티스의 다수의 워커노드에 분산배치되어 있습니다.`
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12}>{CardBox(
                                "자동으로 스케일아웃(Autoscaling)하여 컨테이너 확장, 서비스의 부하분산 구현",
                                `CPU 사용률, 메모리 사용률, 또는 다른 커스텀 메트릭 기준으로 컨테이너(POD) 수량을 주기적으로 조정(증감)합니다. <br>
                                서비스 확장을 위한 하드웨어 자원을 확보할 필요없이 서비스를 구동할 수 있습니다. <br>
                                서비스의 부하분산및 비용을 효율적으로 사용할 수 있는 클러스터 솔루션입니다.`
                                )}
                            </Grid>
                            <DividerComponent />
                            <Grid item xs={12}>{Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-clickhouse/clickhouse.jpeg")}</Grid>
                            <DividerComponent />
                        </Grid>
                        {/* <ClickHouse />
                        <TrafficFee /> */}

                        {KubernetesTable(
                            "ClickHouse 요금안내",
                            "샤딩 및 리플리카, Failover 시스템 기본구성, 대용량 고가용성 분산 클라우드 ClickHouse DBMS",
                            [{
                                row_title: "CPU",
                                col1: "1 Core",
                                col2: "2 Core",
                                col3: "4 Core",
                            },
                            {
                                row_title: "Memory",
                                col1: "4G",
                                col2: "8G",
                                col3: "16G", 
                            },
                            {
                                row_title: "Storage",
                                col1: "SSD 100G",
                                col2: "SSD 100G",
                                col3: "SSD 100G", 
                            },
                            {
                                row_title: "Traffic 전송량(월)",
                                col1: "900G",
                                col2: "900G",
                                col3: "900G", 
                            },
                            {
                                row_title: "가상서버(POD) 최소수량",
                                col1: "가상서버(POD) 4대, LB 1대",
                                col2: "가상서버(POD) 4대, LB 1대",
                                col3: "가상서버(POD) 4대, LB 1대", 
                            }],

                            [{
                                row_title: "서비스비용(월)",
                                col1: "90,000",
                                col2: "160,000",
                                col3: "320,000",
                            }],

                            `- 컨테이너 구성을 고객의 요청에 따라 별도로 지정할 수 있습니다.<br>
                            <span class="geek"><b>
                            - 다양한 방식으로 쿠베네티스 클러스터를 구축할 수 있습니다. (Cloud 구축운영컨설팅)<br>
                            - 가상서버(POD) 5대이상의 자원으로 클러스터를 구성합니다.
                            </b></span>`
                        )},

                        <FeeAndSupport />

                    </Col>
                </Row>
            </Container>
            <Cloudconsult />
            <Footer />
        </div>
    );
};


export default ClusterClickHouseTest;
